type LogoSource = {
  logoFile?: { url?: string | null } | null;
  legacyLogoUrl?: string | null;
};

/**
 * Resolve an entity's logo URL from its storage-backed logo fields: prefer the
 * uploaded storage file, fall back to the legacy URL, otherwise null. Centralizes
 * the `logoFile?.url ?? legacyLogoUrl ?? null` rule shared across the club,
 * organization and federation logo surfaces, and mirrors `resolveAvatarUrl` for users.
 */
export const resolveLogoUrl = (source: LogoSource | null | undefined): string | null =>
  source?.logoFile?.url ?? source?.legacyLogoUrl ?? null;
